'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomboxIcon = exports.ZoomPlusIcon = exports.ZoomMinusIcon = exports.TraceTypeWaterfallIcon = exports.TraceTypeViolinIcon = exports.TraceTypeTimeSeriesIcon = exports.TraceTypeTableIcon = exports.TraceTypeSurfaceIcon = exports.TraceTypeSunburstIcon = exports.TraceTypeStreamtubeIcon = exports.TraceTypeSplomIcon = exports.TraceTypeScatterternaryIcon = exports.TraceTypeScatterpolarIcon = exports.TraceTypeScattermapboxIcon = exports.TraceTypeScattergeoIcon = exports.TraceTypeScatterIcon = exports.TraceTypeScatter3dIcon = exports.TraceTypeSankeyIcon = exports.TraceTypeRangeSliderIcon = exports.TraceTypePieIcon = exports.TraceTypeParcoordsIcon = exports.TraceTypeOhlcIcon = exports.TraceTypeMesh3dIcon = exports.TraceTypeLineIcon = exports.TraceTypeLine3dIcon = exports.TraceTypeHistogramIcon = exports.TraceTypeHistogram2dcontourIcon = undefined;
exports.TraceTypeHistogram2dIcon = exports.TraceTypeHeatmapIcon = exports.TraceTypeFunnelareaIcon = exports.TraceTypeFunnelIcon = exports.TraceTypeErrorBarsIcon = exports.TraceTypeDensitymapboxIcon = exports.TraceTypeContourIcon = exports.TraceTypeConeIcon = exports.TraceTypeChoroplethmapboxIcon = exports.TraceTypeChoroplethIcon = exports.TraceTypeCarpetIcon = exports.TraceTypeCandlestickIcon = exports.TraceTypeBoxIcon = exports.TraceTypeBarpolarIcon = exports.TraceTypeBarIcon = exports.TraceTypeAreaIcon = exports.TraceTypeAnimationIcon = exports.TooltipCompareIcon = exports.TooltipBasicIcon = exports.ThemeNoBrushIcon = exports.ThemeBrushIcon = exports.TemplateSingleIcon = exports.TemplateDoubleIcon = exports.TemplateBoldIcon = exports.SpikelineIcon = exports.ScriptIcon = exports.PlotWaterfallIcon = exports.PlotVolume3dIcon = exports.PlotViolinIcon = exports.PlotTube3dIcon = exports.PlotTimeSeriesIcon = exports.PlotTernaryContourIcon = exports.PlotSurfaceIcon = exports.PlotSunburstIcon = exports.PlotStreamtubeIcon = exports.PlotStackedAreaIcon = exports.PlotSplomIcon = exports.PlotScatterternaryIcon = exports.PlotScatterpolarIcon = exports.PlotScattermapboxIcon = exports.PlotScattergeoIcon = exports.PlotScatterMatrixIcon = exports.PlotScatterIcon = exports.PlotScatterChartIcon = exports.PlotScatterAxesIcon = exports.PlotScatter3dIcon = exports.PlotSankeyIcon = exports.PlotRadarIcon = exports.PlotPolarFilledIcon = exports.PlotPieShadedIcon = exports.PlotPieIcon = exports.PlotParcoordsIcon = exports.PlotOhlcIcon = exports.PlotMesh3dIcon = exports.PlotMapLineIcon = exports.PlotLineMarkersIcon = exports.PlotLineIcon = exports.PlotLine3dIcon = exports.PlotIsosurface3dIcon = exports.PlotIcon = exports.PlotHistogramIcon = exports.PlotHistogram2dcontourIcon = exports.PlotHistogram2dIcon = exports.PlotHistogram2dBricksIcon = exports.PlotHeatmapIcon = exports.PlotFunnelareaIcon = exports.PlotFunnelIcon = exports.PlotFitIcon = exports.PlotErrorBarsIcon = exports.PlotDonutIcon = exports.PlotDensitymapboxIcon = exports.PlotContourIcon = exports.PlotConeIcon = exports.PlotCone3dIcon = exports.PlotChoroplethmapboxIcon = exports.PlotChoroplethIcon = exports.PlotCarpetIcon = exports.PlotCandlestickIcon = exports.PlotCandlestickAltIcon = exports.PlotBubblesIcon = exports.PlotBoxIcon = exports.PlotBarpolarIcon = exports.PlotBarIcon = exports.PlotBarAxesIcon = exports.PlotAreaStackedIcon = exports.PlotAreaIcon = exports.PanIcon = exports.NotebookRIcon = exports.NotebookMIconIcon = exports.NotebookIpIcon = exports.LogoVisaIcon = exports.LogoStripeIcon = exports.LogoMastercardIcon = exports.LogoAmexIcon = exports.GearsSettingIcon = exports.ForkIcon = exports.ForkEditIcon = exports.FilingCabinetIcon = exports.EmbedIconIcon = exports.AutoscaleIcon = undefined;

var _AutoscaleIcon2 = require('./AutoscaleIcon.js');

var _AutoscaleIcon3 = _interopRequireDefault(_AutoscaleIcon2);

var _EmbedIconIcon2 = require('./EmbedIconIcon.js');

var _EmbedIconIcon3 = _interopRequireDefault(_EmbedIconIcon2);

var _FilingCabinetIcon2 = require('./FilingCabinetIcon.js');

var _FilingCabinetIcon3 = _interopRequireDefault(_FilingCabinetIcon2);

var _ForkEditIcon2 = require('./ForkEditIcon.js');

var _ForkEditIcon3 = _interopRequireDefault(_ForkEditIcon2);

var _ForkIcon2 = require('./ForkIcon.js');

var _ForkIcon3 = _interopRequireDefault(_ForkIcon2);

var _GearsSettingIcon2 = require('./GearsSettingIcon.js');

var _GearsSettingIcon3 = _interopRequireDefault(_GearsSettingIcon2);

var _LogoAmexIcon2 = require('./LogoAmexIcon.js');

var _LogoAmexIcon3 = _interopRequireDefault(_LogoAmexIcon2);

var _LogoMastercardIcon2 = require('./LogoMastercardIcon.js');

var _LogoMastercardIcon3 = _interopRequireDefault(_LogoMastercardIcon2);

var _LogoStripeIcon2 = require('./LogoStripeIcon.js');

var _LogoStripeIcon3 = _interopRequireDefault(_LogoStripeIcon2);

var _LogoVisaIcon2 = require('./LogoVisaIcon.js');

var _LogoVisaIcon3 = _interopRequireDefault(_LogoVisaIcon2);

var _NotebookIpIcon2 = require('./NotebookIpIcon.js');

var _NotebookIpIcon3 = _interopRequireDefault(_NotebookIpIcon2);

var _NotebookMIconIcon2 = require('./NotebookMIconIcon.js');

var _NotebookMIconIcon3 = _interopRequireDefault(_NotebookMIconIcon2);

var _NotebookRIcon2 = require('./NotebookRIcon.js');

var _NotebookRIcon3 = _interopRequireDefault(_NotebookRIcon2);

var _PanIcon2 = require('./PanIcon.js');

var _PanIcon3 = _interopRequireDefault(_PanIcon2);

var _PlotAreaIcon2 = require('./PlotAreaIcon.js');

var _PlotAreaIcon3 = _interopRequireDefault(_PlotAreaIcon2);

var _PlotAreaStackedIcon2 = require('./PlotAreaStackedIcon.js');

var _PlotAreaStackedIcon3 = _interopRequireDefault(_PlotAreaStackedIcon2);

var _PlotBarAxesIcon2 = require('./PlotBarAxesIcon.js');

var _PlotBarAxesIcon3 = _interopRequireDefault(_PlotBarAxesIcon2);

var _PlotBarIcon2 = require('./PlotBarIcon.js');

var _PlotBarIcon3 = _interopRequireDefault(_PlotBarIcon2);

var _PlotBarpolarIcon2 = require('./PlotBarpolarIcon.js');

var _PlotBarpolarIcon3 = _interopRequireDefault(_PlotBarpolarIcon2);

var _PlotBoxIcon2 = require('./PlotBoxIcon.js');

var _PlotBoxIcon3 = _interopRequireDefault(_PlotBoxIcon2);

var _PlotBubblesIcon2 = require('./PlotBubblesIcon.js');

var _PlotBubblesIcon3 = _interopRequireDefault(_PlotBubblesIcon2);

var _PlotCandlestickAltIcon2 = require('./PlotCandlestickAltIcon.js');

var _PlotCandlestickAltIcon3 = _interopRequireDefault(_PlotCandlestickAltIcon2);

var _PlotCandlestickIcon2 = require('./PlotCandlestickIcon.js');

var _PlotCandlestickIcon3 = _interopRequireDefault(_PlotCandlestickIcon2);

var _PlotCarpetIcon2 = require('./PlotCarpetIcon.js');

var _PlotCarpetIcon3 = _interopRequireDefault(_PlotCarpetIcon2);

var _PlotChoroplethIcon2 = require('./PlotChoroplethIcon.js');

var _PlotChoroplethIcon3 = _interopRequireDefault(_PlotChoroplethIcon2);

var _PlotChoroplethmapboxIcon2 = require('./PlotChoroplethmapboxIcon.js');

var _PlotChoroplethmapboxIcon3 = _interopRequireDefault(_PlotChoroplethmapboxIcon2);

var _PlotCone3dIcon2 = require('./PlotCone3dIcon.js');

var _PlotCone3dIcon3 = _interopRequireDefault(_PlotCone3dIcon2);

var _PlotConeIcon2 = require('./PlotConeIcon.js');

var _PlotConeIcon3 = _interopRequireDefault(_PlotConeIcon2);

var _PlotContourIcon2 = require('./PlotContourIcon.js');

var _PlotContourIcon3 = _interopRequireDefault(_PlotContourIcon2);

var _PlotDensitymapboxIcon2 = require('./PlotDensitymapboxIcon.js');

var _PlotDensitymapboxIcon3 = _interopRequireDefault(_PlotDensitymapboxIcon2);

var _PlotDonutIcon2 = require('./PlotDonutIcon.js');

var _PlotDonutIcon3 = _interopRequireDefault(_PlotDonutIcon2);

var _PlotErrorBarsIcon2 = require('./PlotErrorBarsIcon.js');

var _PlotErrorBarsIcon3 = _interopRequireDefault(_PlotErrorBarsIcon2);

var _PlotFitIcon2 = require('./PlotFitIcon.js');

var _PlotFitIcon3 = _interopRequireDefault(_PlotFitIcon2);

var _PlotFunnelIcon2 = require('./PlotFunnelIcon.js');

var _PlotFunnelIcon3 = _interopRequireDefault(_PlotFunnelIcon2);

var _PlotFunnelareaIcon2 = require('./PlotFunnelareaIcon.js');

var _PlotFunnelareaIcon3 = _interopRequireDefault(_PlotFunnelareaIcon2);

var _PlotHeatmapIcon2 = require('./PlotHeatmapIcon.js');

var _PlotHeatmapIcon3 = _interopRequireDefault(_PlotHeatmapIcon2);

var _PlotHistogram2dBricksIcon2 = require('./PlotHistogram2dBricksIcon.js');

var _PlotHistogram2dBricksIcon3 = _interopRequireDefault(_PlotHistogram2dBricksIcon2);

var _PlotHistogram2dIcon2 = require('./PlotHistogram2dIcon.js');

var _PlotHistogram2dIcon3 = _interopRequireDefault(_PlotHistogram2dIcon2);

var _PlotHistogram2dcontourIcon2 = require('./PlotHistogram2dcontourIcon.js');

var _PlotHistogram2dcontourIcon3 = _interopRequireDefault(_PlotHistogram2dcontourIcon2);

var _PlotHistogramIcon2 = require('./PlotHistogramIcon.js');

var _PlotHistogramIcon3 = _interopRequireDefault(_PlotHistogramIcon2);

var _PlotIcon2 = require('./PlotIcon.js');

var _PlotIcon3 = _interopRequireDefault(_PlotIcon2);

var _PlotIsosurface3dIcon2 = require('./PlotIsosurface3dIcon.js');

var _PlotIsosurface3dIcon3 = _interopRequireDefault(_PlotIsosurface3dIcon2);

var _PlotLine3dIcon2 = require('./PlotLine3dIcon.js');

var _PlotLine3dIcon3 = _interopRequireDefault(_PlotLine3dIcon2);

var _PlotLineIcon2 = require('./PlotLineIcon.js');

var _PlotLineIcon3 = _interopRequireDefault(_PlotLineIcon2);

var _PlotLineMarkersIcon2 = require('./PlotLineMarkersIcon.js');

var _PlotLineMarkersIcon3 = _interopRequireDefault(_PlotLineMarkersIcon2);

var _PlotMapLineIcon2 = require('./PlotMapLineIcon.js');

var _PlotMapLineIcon3 = _interopRequireDefault(_PlotMapLineIcon2);

var _PlotMesh3dIcon2 = require('./PlotMesh3dIcon.js');

var _PlotMesh3dIcon3 = _interopRequireDefault(_PlotMesh3dIcon2);

var _PlotOhlcIcon2 = require('./PlotOhlcIcon.js');

var _PlotOhlcIcon3 = _interopRequireDefault(_PlotOhlcIcon2);

var _PlotParcoordsIcon2 = require('./PlotParcoordsIcon.js');

var _PlotParcoordsIcon3 = _interopRequireDefault(_PlotParcoordsIcon2);

var _PlotPieIcon2 = require('./PlotPieIcon.js');

var _PlotPieIcon3 = _interopRequireDefault(_PlotPieIcon2);

var _PlotPieShadedIcon2 = require('./PlotPieShadedIcon.js');

var _PlotPieShadedIcon3 = _interopRequireDefault(_PlotPieShadedIcon2);

var _PlotPolarFilledIcon2 = require('./PlotPolarFilledIcon.js');

var _PlotPolarFilledIcon3 = _interopRequireDefault(_PlotPolarFilledIcon2);

var _PlotRadarIcon2 = require('./PlotRadarIcon.js');

var _PlotRadarIcon3 = _interopRequireDefault(_PlotRadarIcon2);

var _PlotSankeyIcon2 = require('./PlotSankeyIcon.js');

var _PlotSankeyIcon3 = _interopRequireDefault(_PlotSankeyIcon2);

var _PlotScatter3dIcon2 = require('./PlotScatter3dIcon.js');

var _PlotScatter3dIcon3 = _interopRequireDefault(_PlotScatter3dIcon2);

var _PlotScatterAxesIcon2 = require('./PlotScatterAxesIcon.js');

var _PlotScatterAxesIcon3 = _interopRequireDefault(_PlotScatterAxesIcon2);

var _PlotScatterChartIcon2 = require('./PlotScatterChartIcon.js');

var _PlotScatterChartIcon3 = _interopRequireDefault(_PlotScatterChartIcon2);

var _PlotScatterIcon2 = require('./PlotScatterIcon.js');

var _PlotScatterIcon3 = _interopRequireDefault(_PlotScatterIcon2);

var _PlotScatterMatrixIcon2 = require('./PlotScatterMatrixIcon.js');

var _PlotScatterMatrixIcon3 = _interopRequireDefault(_PlotScatterMatrixIcon2);

var _PlotScattergeoIcon2 = require('./PlotScattergeoIcon.js');

var _PlotScattergeoIcon3 = _interopRequireDefault(_PlotScattergeoIcon2);

var _PlotScattermapboxIcon2 = require('./PlotScattermapboxIcon.js');

var _PlotScattermapboxIcon3 = _interopRequireDefault(_PlotScattermapboxIcon2);

var _PlotScatterpolarIcon2 = require('./PlotScatterpolarIcon.js');

var _PlotScatterpolarIcon3 = _interopRequireDefault(_PlotScatterpolarIcon2);

var _PlotScatterternaryIcon2 = require('./PlotScatterternaryIcon.js');

var _PlotScatterternaryIcon3 = _interopRequireDefault(_PlotScatterternaryIcon2);

var _PlotSplomIcon2 = require('./PlotSplomIcon.js');

var _PlotSplomIcon3 = _interopRequireDefault(_PlotSplomIcon2);

var _PlotStackedAreaIcon2 = require('./PlotStackedAreaIcon.js');

var _PlotStackedAreaIcon3 = _interopRequireDefault(_PlotStackedAreaIcon2);

var _PlotStreamtubeIcon2 = require('./PlotStreamtubeIcon.js');

var _PlotStreamtubeIcon3 = _interopRequireDefault(_PlotStreamtubeIcon2);

var _PlotSunburstIcon2 = require('./PlotSunburstIcon.js');

var _PlotSunburstIcon3 = _interopRequireDefault(_PlotSunburstIcon2);

var _PlotSurfaceIcon2 = require('./PlotSurfaceIcon.js');

var _PlotSurfaceIcon3 = _interopRequireDefault(_PlotSurfaceIcon2);

var _PlotTernaryContourIcon2 = require('./PlotTernaryContourIcon.js');

var _PlotTernaryContourIcon3 = _interopRequireDefault(_PlotTernaryContourIcon2);

var _PlotTimeSeriesIcon2 = require('./PlotTimeSeriesIcon.js');

var _PlotTimeSeriesIcon3 = _interopRequireDefault(_PlotTimeSeriesIcon2);

var _PlotTube3dIcon2 = require('./PlotTube3dIcon.js');

var _PlotTube3dIcon3 = _interopRequireDefault(_PlotTube3dIcon2);

var _PlotViolinIcon2 = require('./PlotViolinIcon.js');

var _PlotViolinIcon3 = _interopRequireDefault(_PlotViolinIcon2);

var _PlotVolume3dIcon2 = require('./PlotVolume3dIcon.js');

var _PlotVolume3dIcon3 = _interopRequireDefault(_PlotVolume3dIcon2);

var _PlotWaterfallIcon2 = require('./PlotWaterfallIcon.js');

var _PlotWaterfallIcon3 = _interopRequireDefault(_PlotWaterfallIcon2);

var _ScriptIcon2 = require('./ScriptIcon.js');

var _ScriptIcon3 = _interopRequireDefault(_ScriptIcon2);

var _SpikelineIcon2 = require('./SpikelineIcon.js');

var _SpikelineIcon3 = _interopRequireDefault(_SpikelineIcon2);

var _TemplateBoldIcon2 = require('./TemplateBoldIcon.js');

var _TemplateBoldIcon3 = _interopRequireDefault(_TemplateBoldIcon2);

var _TemplateDoubleIcon2 = require('./TemplateDoubleIcon.js');

var _TemplateDoubleIcon3 = _interopRequireDefault(_TemplateDoubleIcon2);

var _TemplateSingleIcon2 = require('./TemplateSingleIcon.js');

var _TemplateSingleIcon3 = _interopRequireDefault(_TemplateSingleIcon2);

var _ThemeBrushIcon2 = require('./ThemeBrushIcon.js');

var _ThemeBrushIcon3 = _interopRequireDefault(_ThemeBrushIcon2);

var _ThemeNoBrushIcon2 = require('./ThemeNoBrushIcon.js');

var _ThemeNoBrushIcon3 = _interopRequireDefault(_ThemeNoBrushIcon2);

var _TooltipBasicIcon2 = require('./TooltipBasicIcon.js');

var _TooltipBasicIcon3 = _interopRequireDefault(_TooltipBasicIcon2);

var _TooltipCompareIcon2 = require('./TooltipCompareIcon.js');

var _TooltipCompareIcon3 = _interopRequireDefault(_TooltipCompareIcon2);

var _TraceTypeAnimationIcon2 = require('./TraceTypeAnimationIcon.js');

var _TraceTypeAnimationIcon3 = _interopRequireDefault(_TraceTypeAnimationIcon2);

var _TraceTypeAreaIcon2 = require('./TraceTypeAreaIcon.js');

var _TraceTypeAreaIcon3 = _interopRequireDefault(_TraceTypeAreaIcon2);

var _TraceTypeBarIcon2 = require('./TraceTypeBarIcon.js');

var _TraceTypeBarIcon3 = _interopRequireDefault(_TraceTypeBarIcon2);

var _TraceTypeBarpolarIcon2 = require('./TraceTypeBarpolarIcon.js');

var _TraceTypeBarpolarIcon3 = _interopRequireDefault(_TraceTypeBarpolarIcon2);

var _TraceTypeBoxIcon2 = require('./TraceTypeBoxIcon.js');

var _TraceTypeBoxIcon3 = _interopRequireDefault(_TraceTypeBoxIcon2);

var _TraceTypeCandlestickIcon2 = require('./TraceTypeCandlestickIcon.js');

var _TraceTypeCandlestickIcon3 = _interopRequireDefault(_TraceTypeCandlestickIcon2);

var _TraceTypeCarpetIcon2 = require('./TraceTypeCarpetIcon.js');

var _TraceTypeCarpetIcon3 = _interopRequireDefault(_TraceTypeCarpetIcon2);

var _TraceTypeChoroplethIcon2 = require('./TraceTypeChoroplethIcon.js');

var _TraceTypeChoroplethIcon3 = _interopRequireDefault(_TraceTypeChoroplethIcon2);

var _TraceTypeChoroplethmapboxIcon2 = require('./TraceTypeChoroplethmapboxIcon.js');

var _TraceTypeChoroplethmapboxIcon3 = _interopRequireDefault(_TraceTypeChoroplethmapboxIcon2);

var _TraceTypeConeIcon2 = require('./TraceTypeConeIcon.js');

var _TraceTypeConeIcon3 = _interopRequireDefault(_TraceTypeConeIcon2);

var _TraceTypeContourIcon2 = require('./TraceTypeContourIcon.js');

var _TraceTypeContourIcon3 = _interopRequireDefault(_TraceTypeContourIcon2);

var _TraceTypeDensitymapboxIcon2 = require('./TraceTypeDensitymapboxIcon.js');

var _TraceTypeDensitymapboxIcon3 = _interopRequireDefault(_TraceTypeDensitymapboxIcon2);

var _TraceTypeErrorBarsIcon2 = require('./TraceTypeErrorBarsIcon.js');

var _TraceTypeErrorBarsIcon3 = _interopRequireDefault(_TraceTypeErrorBarsIcon2);

var _TraceTypeFunnelIcon2 = require('./TraceTypeFunnelIcon.js');

var _TraceTypeFunnelIcon3 = _interopRequireDefault(_TraceTypeFunnelIcon2);

var _TraceTypeFunnelareaIcon2 = require('./TraceTypeFunnelareaIcon.js');

var _TraceTypeFunnelareaIcon3 = _interopRequireDefault(_TraceTypeFunnelareaIcon2);

var _TraceTypeHeatmapIcon2 = require('./TraceTypeHeatmapIcon.js');

var _TraceTypeHeatmapIcon3 = _interopRequireDefault(_TraceTypeHeatmapIcon2);

var _TraceTypeHistogram2dIcon2 = require('./TraceTypeHistogram2dIcon.js');

var _TraceTypeHistogram2dIcon3 = _interopRequireDefault(_TraceTypeHistogram2dIcon2);

var _TraceTypeHistogram2dcontourIcon2 = require('./TraceTypeHistogram2dcontourIcon.js');

var _TraceTypeHistogram2dcontourIcon3 = _interopRequireDefault(_TraceTypeHistogram2dcontourIcon2);

var _TraceTypeHistogramIcon2 = require('./TraceTypeHistogramIcon.js');

var _TraceTypeHistogramIcon3 = _interopRequireDefault(_TraceTypeHistogramIcon2);

var _TraceTypeLine3dIcon2 = require('./TraceTypeLine3dIcon.js');

var _TraceTypeLine3dIcon3 = _interopRequireDefault(_TraceTypeLine3dIcon2);

var _TraceTypeLineIcon2 = require('./TraceTypeLineIcon.js');

var _TraceTypeLineIcon3 = _interopRequireDefault(_TraceTypeLineIcon2);

var _TraceTypeMesh3dIcon2 = require('./TraceTypeMesh3dIcon.js');

var _TraceTypeMesh3dIcon3 = _interopRequireDefault(_TraceTypeMesh3dIcon2);

var _TraceTypeOhlcIcon2 = require('./TraceTypeOhlcIcon.js');

var _TraceTypeOhlcIcon3 = _interopRequireDefault(_TraceTypeOhlcIcon2);

var _TraceTypeParcoordsIcon2 = require('./TraceTypeParcoordsIcon.js');

var _TraceTypeParcoordsIcon3 = _interopRequireDefault(_TraceTypeParcoordsIcon2);

var _TraceTypePieIcon2 = require('./TraceTypePieIcon.js');

var _TraceTypePieIcon3 = _interopRequireDefault(_TraceTypePieIcon2);

var _TraceTypeRangeSliderIcon2 = require('./TraceTypeRangeSliderIcon.js');

var _TraceTypeRangeSliderIcon3 = _interopRequireDefault(_TraceTypeRangeSliderIcon2);

var _TraceTypeSankeyIcon2 = require('./TraceTypeSankeyIcon.js');

var _TraceTypeSankeyIcon3 = _interopRequireDefault(_TraceTypeSankeyIcon2);

var _TraceTypeScatter3dIcon2 = require('./TraceTypeScatter3dIcon.js');

var _TraceTypeScatter3dIcon3 = _interopRequireDefault(_TraceTypeScatter3dIcon2);

var _TraceTypeScatterIcon2 = require('./TraceTypeScatterIcon.js');

var _TraceTypeScatterIcon3 = _interopRequireDefault(_TraceTypeScatterIcon2);

var _TraceTypeScattergeoIcon2 = require('./TraceTypeScattergeoIcon.js');

var _TraceTypeScattergeoIcon3 = _interopRequireDefault(_TraceTypeScattergeoIcon2);

var _TraceTypeScattermapboxIcon2 = require('./TraceTypeScattermapboxIcon.js');

var _TraceTypeScattermapboxIcon3 = _interopRequireDefault(_TraceTypeScattermapboxIcon2);

var _TraceTypeScatterpolarIcon2 = require('./TraceTypeScatterpolarIcon.js');

var _TraceTypeScatterpolarIcon3 = _interopRequireDefault(_TraceTypeScatterpolarIcon2);

var _TraceTypeScatterternaryIcon2 = require('./TraceTypeScatterternaryIcon.js');

var _TraceTypeScatterternaryIcon3 = _interopRequireDefault(_TraceTypeScatterternaryIcon2);

var _TraceTypeSplomIcon2 = require('./TraceTypeSplomIcon.js');

var _TraceTypeSplomIcon3 = _interopRequireDefault(_TraceTypeSplomIcon2);

var _TraceTypeStreamtubeIcon2 = require('./TraceTypeStreamtubeIcon.js');

var _TraceTypeStreamtubeIcon3 = _interopRequireDefault(_TraceTypeStreamtubeIcon2);

var _TraceTypeSunburstIcon2 = require('./TraceTypeSunburstIcon.js');

var _TraceTypeSunburstIcon3 = _interopRequireDefault(_TraceTypeSunburstIcon2);

var _TraceTypeSurfaceIcon2 = require('./TraceTypeSurfaceIcon.js');

var _TraceTypeSurfaceIcon3 = _interopRequireDefault(_TraceTypeSurfaceIcon2);

var _TraceTypeTableIcon2 = require('./TraceTypeTableIcon.js');

var _TraceTypeTableIcon3 = _interopRequireDefault(_TraceTypeTableIcon2);

var _TraceTypeTimeSeriesIcon2 = require('./TraceTypeTimeSeriesIcon.js');

var _TraceTypeTimeSeriesIcon3 = _interopRequireDefault(_TraceTypeTimeSeriesIcon2);

var _TraceTypeViolinIcon2 = require('./TraceTypeViolinIcon.js');

var _TraceTypeViolinIcon3 = _interopRequireDefault(_TraceTypeViolinIcon2);

var _TraceTypeWaterfallIcon2 = require('./TraceTypeWaterfallIcon.js');

var _TraceTypeWaterfallIcon3 = _interopRequireDefault(_TraceTypeWaterfallIcon2);

var _ZoomMinusIcon2 = require('./ZoomMinusIcon.js');

var _ZoomMinusIcon3 = _interopRequireDefault(_ZoomMinusIcon2);

var _ZoomPlusIcon2 = require('./ZoomPlusIcon.js');

var _ZoomPlusIcon3 = _interopRequireDefault(_ZoomPlusIcon2);

var _ZoomboxIcon2 = require('./ZoomboxIcon.js');

var _ZoomboxIcon3 = _interopRequireDefault(_ZoomboxIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AutoscaleIcon = _AutoscaleIcon3.default;
exports.EmbedIconIcon = _EmbedIconIcon3.default;
exports.FilingCabinetIcon = _FilingCabinetIcon3.default;
exports.ForkEditIcon = _ForkEditIcon3.default;
exports.ForkIcon = _ForkIcon3.default;
exports.GearsSettingIcon = _GearsSettingIcon3.default;
exports.LogoAmexIcon = _LogoAmexIcon3.default;
exports.LogoMastercardIcon = _LogoMastercardIcon3.default;
exports.LogoStripeIcon = _LogoStripeIcon3.default;
exports.LogoVisaIcon = _LogoVisaIcon3.default;
exports.NotebookIpIcon = _NotebookIpIcon3.default;
exports.NotebookMIconIcon = _NotebookMIconIcon3.default;
exports.NotebookRIcon = _NotebookRIcon3.default;
exports.PanIcon = _PanIcon3.default;
exports.PlotAreaIcon = _PlotAreaIcon3.default;
exports.PlotAreaStackedIcon = _PlotAreaStackedIcon3.default;
exports.PlotBarAxesIcon = _PlotBarAxesIcon3.default;
exports.PlotBarIcon = _PlotBarIcon3.default;
exports.PlotBarpolarIcon = _PlotBarpolarIcon3.default;
exports.PlotBoxIcon = _PlotBoxIcon3.default;
exports.PlotBubblesIcon = _PlotBubblesIcon3.default;
exports.PlotCandlestickAltIcon = _PlotCandlestickAltIcon3.default;
exports.PlotCandlestickIcon = _PlotCandlestickIcon3.default;
exports.PlotCarpetIcon = _PlotCarpetIcon3.default;
exports.PlotChoroplethIcon = _PlotChoroplethIcon3.default;
exports.PlotChoroplethmapboxIcon = _PlotChoroplethmapboxIcon3.default;
exports.PlotCone3dIcon = _PlotCone3dIcon3.default;
exports.PlotConeIcon = _PlotConeIcon3.default;
exports.PlotContourIcon = _PlotContourIcon3.default;
exports.PlotDensitymapboxIcon = _PlotDensitymapboxIcon3.default;
exports.PlotDonutIcon = _PlotDonutIcon3.default;
exports.PlotErrorBarsIcon = _PlotErrorBarsIcon3.default;
exports.PlotFitIcon = _PlotFitIcon3.default;
exports.PlotFunnelIcon = _PlotFunnelIcon3.default;
exports.PlotFunnelareaIcon = _PlotFunnelareaIcon3.default;
exports.PlotHeatmapIcon = _PlotHeatmapIcon3.default;
exports.PlotHistogram2dBricksIcon = _PlotHistogram2dBricksIcon3.default;
exports.PlotHistogram2dIcon = _PlotHistogram2dIcon3.default;
exports.PlotHistogram2dcontourIcon = _PlotHistogram2dcontourIcon3.default;
exports.PlotHistogramIcon = _PlotHistogramIcon3.default;
exports.PlotIcon = _PlotIcon3.default;
exports.PlotIsosurface3dIcon = _PlotIsosurface3dIcon3.default;
exports.PlotLine3dIcon = _PlotLine3dIcon3.default;
exports.PlotLineIcon = _PlotLineIcon3.default;
exports.PlotLineMarkersIcon = _PlotLineMarkersIcon3.default;
exports.PlotMapLineIcon = _PlotMapLineIcon3.default;
exports.PlotMesh3dIcon = _PlotMesh3dIcon3.default;
exports.PlotOhlcIcon = _PlotOhlcIcon3.default;
exports.PlotParcoordsIcon = _PlotParcoordsIcon3.default;
exports.PlotPieIcon = _PlotPieIcon3.default;
exports.PlotPieShadedIcon = _PlotPieShadedIcon3.default;
exports.PlotPolarFilledIcon = _PlotPolarFilledIcon3.default;
exports.PlotRadarIcon = _PlotRadarIcon3.default;
exports.PlotSankeyIcon = _PlotSankeyIcon3.default;
exports.PlotScatter3dIcon = _PlotScatter3dIcon3.default;
exports.PlotScatterAxesIcon = _PlotScatterAxesIcon3.default;
exports.PlotScatterChartIcon = _PlotScatterChartIcon3.default;
exports.PlotScatterIcon = _PlotScatterIcon3.default;
exports.PlotScatterMatrixIcon = _PlotScatterMatrixIcon3.default;
exports.PlotScattergeoIcon = _PlotScattergeoIcon3.default;
exports.PlotScattermapboxIcon = _PlotScattermapboxIcon3.default;
exports.PlotScatterpolarIcon = _PlotScatterpolarIcon3.default;
exports.PlotScatterternaryIcon = _PlotScatterternaryIcon3.default;
exports.PlotSplomIcon = _PlotSplomIcon3.default;
exports.PlotStackedAreaIcon = _PlotStackedAreaIcon3.default;
exports.PlotStreamtubeIcon = _PlotStreamtubeIcon3.default;
exports.PlotSunburstIcon = _PlotSunburstIcon3.default;
exports.PlotSurfaceIcon = _PlotSurfaceIcon3.default;
exports.PlotTernaryContourIcon = _PlotTernaryContourIcon3.default;
exports.PlotTimeSeriesIcon = _PlotTimeSeriesIcon3.default;
exports.PlotTube3dIcon = _PlotTube3dIcon3.default;
exports.PlotViolinIcon = _PlotViolinIcon3.default;
exports.PlotVolume3dIcon = _PlotVolume3dIcon3.default;
exports.PlotWaterfallIcon = _PlotWaterfallIcon3.default;
exports.ScriptIcon = _ScriptIcon3.default;
exports.SpikelineIcon = _SpikelineIcon3.default;
exports.TemplateBoldIcon = _TemplateBoldIcon3.default;
exports.TemplateDoubleIcon = _TemplateDoubleIcon3.default;
exports.TemplateSingleIcon = _TemplateSingleIcon3.default;
exports.ThemeBrushIcon = _ThemeBrushIcon3.default;
exports.ThemeNoBrushIcon = _ThemeNoBrushIcon3.default;
exports.TooltipBasicIcon = _TooltipBasicIcon3.default;
exports.TooltipCompareIcon = _TooltipCompareIcon3.default;
exports.TraceTypeAnimationIcon = _TraceTypeAnimationIcon3.default;
exports.TraceTypeAreaIcon = _TraceTypeAreaIcon3.default;
exports.TraceTypeBarIcon = _TraceTypeBarIcon3.default;
exports.TraceTypeBarpolarIcon = _TraceTypeBarpolarIcon3.default;
exports.TraceTypeBoxIcon = _TraceTypeBoxIcon3.default;
exports.TraceTypeCandlestickIcon = _TraceTypeCandlestickIcon3.default;
exports.TraceTypeCarpetIcon = _TraceTypeCarpetIcon3.default;
exports.TraceTypeChoroplethIcon = _TraceTypeChoroplethIcon3.default;
exports.TraceTypeChoroplethmapboxIcon = _TraceTypeChoroplethmapboxIcon3.default;
exports.TraceTypeConeIcon = _TraceTypeConeIcon3.default;
exports.TraceTypeContourIcon = _TraceTypeContourIcon3.default;
exports.TraceTypeDensitymapboxIcon = _TraceTypeDensitymapboxIcon3.default;
exports.TraceTypeErrorBarsIcon = _TraceTypeErrorBarsIcon3.default;
exports.TraceTypeFunnelIcon = _TraceTypeFunnelIcon3.default;
exports.TraceTypeFunnelareaIcon = _TraceTypeFunnelareaIcon3.default;
exports.TraceTypeHeatmapIcon = _TraceTypeHeatmapIcon3.default;
exports.TraceTypeHistogram2dIcon = _TraceTypeHistogram2dIcon3.default;
exports.TraceTypeHistogram2dcontourIcon = _TraceTypeHistogram2dcontourIcon3.default;
exports.TraceTypeHistogramIcon = _TraceTypeHistogramIcon3.default;
exports.TraceTypeLine3dIcon = _TraceTypeLine3dIcon3.default;
exports.TraceTypeLineIcon = _TraceTypeLineIcon3.default;
exports.TraceTypeMesh3dIcon = _TraceTypeMesh3dIcon3.default;
exports.TraceTypeOhlcIcon = _TraceTypeOhlcIcon3.default;
exports.TraceTypeParcoordsIcon = _TraceTypeParcoordsIcon3.default;
exports.TraceTypePieIcon = _TraceTypePieIcon3.default;
exports.TraceTypeRangeSliderIcon = _TraceTypeRangeSliderIcon3.default;
exports.TraceTypeSankeyIcon = _TraceTypeSankeyIcon3.default;
exports.TraceTypeScatter3dIcon = _TraceTypeScatter3dIcon3.default;
exports.TraceTypeScatterIcon = _TraceTypeScatterIcon3.default;
exports.TraceTypeScattergeoIcon = _TraceTypeScattergeoIcon3.default;
exports.TraceTypeScattermapboxIcon = _TraceTypeScattermapboxIcon3.default;
exports.TraceTypeScatterpolarIcon = _TraceTypeScatterpolarIcon3.default;
exports.TraceTypeScatterternaryIcon = _TraceTypeScatterternaryIcon3.default;
exports.TraceTypeSplomIcon = _TraceTypeSplomIcon3.default;
exports.TraceTypeStreamtubeIcon = _TraceTypeStreamtubeIcon3.default;
exports.TraceTypeSunburstIcon = _TraceTypeSunburstIcon3.default;
exports.TraceTypeSurfaceIcon = _TraceTypeSurfaceIcon3.default;
exports.TraceTypeTableIcon = _TraceTypeTableIcon3.default;
exports.TraceTypeTimeSeriesIcon = _TraceTypeTimeSeriesIcon3.default;
exports.TraceTypeViolinIcon = _TraceTypeViolinIcon3.default;
exports.TraceTypeWaterfallIcon = _TraceTypeWaterfallIcon3.default;
exports.ZoomMinusIcon = _ZoomMinusIcon3.default;
exports.ZoomPlusIcon = _ZoomPlusIcon3.default;
exports.ZoomboxIcon = _ZoomboxIcon3.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/index.js
// module id = 337
// module chunks = 0